import { Button, Dropdown, MenuProps } from 'antd';
import { Settings, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import { useAuth } from '../../Hooks/useAuth';
import { UserProfile } from '../../types/userTypes';

interface UserProfileModalProps {
    user: UserProfile;
    onLogout: () => void;
}

const UserProfileModal = ({ user, onLogout }: UserProfileModalProps) => {
    const navigate = useNavigate();
    const { user: authUser } = useAuth();

    // Check if user exists and has required properties
    const userImage = user?.photo_url || user?.photo_url;
    const userName = user?.name || 'User';
    const userEmail = user?.email || '';
    const userId = user?.id || authUser?.id;

    const goToSettings = () => {
        if (userId) {
            navigate(`/profile/${userId}?tab=5`);
        }
    };

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <Link to={`/profile/${userId}`}>
                    <div className="flex items-center space-x-3 p-2">
                        {userImage ? (
                            <img src={userImage} alt="Profil" className="h-8 w-8 rounded-full object-cover" />
                        ) : (
                            <div className="border-2 p-1 rounded-full primary-gradient text-primary-default">
                                <div className="bg-light-default p-1 rounded-full">
                                    <User size={20} className="text-gradient bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500" />
                                </div>
                            </div>
                        )}
                        <div className="flex flex-col">
                            <span className="font-medium text-primary-default">{userName}</span>
                            <span className="text-sm text-content-default font-normal">{userEmail}</span>
                        </div>
                    </div>
                </Link>
            ),
        },
        {
            type: 'divider',
        },
        {
            key: '2',
            label: (
                <Button
                    type="primary"
                    size="middle"
                    className="bg-gradient-to-r from-primary-secondary to-primary-default border-0 h-8 px-6 w-full"
                    onClick={goToSettings}
                >                    <span className="flex items-center">
                        <Settings className="mr-2" />
                        Paramètres
                    </span>
                </Button>
            ),
        },
        {
            key: '3',
            label: (
                <Button
                    type="primary"
                    size="middle"
                    className="bg-gradient-to-r from-accent-secondary to-accent-default border-0 h-8 px-6 w-full"
                    onClick={onLogout}
                >                    <span className="flex items-center">
                        <RiLogoutCircleRLine className="mr-2" />
                        Se Déconnecter
                    </span>
                </Button>
            ),
        },
    ];

    return (
        <Dropdown
            menu={{ items }}
            placement="bottomRight"
            arrow
            trigger={['click']}
        >
            <button className="flex items-center">
                {userImage ? (
                    <div className="flex flex-col justify-center items-center text-primary-default gap-0.5">
                        <img
                            src={userImage}
                            alt="Profil"
                            className="h-9 w-9 rounded-full -mb-0.5 object-cover"
                        />
                        <p className="text-sm font-semibold text-primary-default">
                            Profil
                        </p>
                    </div>
                ) : (
                    <div className="flex items-center flex-col justify-center text-primary-default">
                        <div className="border-2 p-1 rounded-full primary-gradient">
                            <div className="bg-light-default p-1 rounded-full">
                                <User size={20} className="text-gradient bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500" />
                            </div>
                        </div>
                        <p className="text-sm font-bold primary-gradient-text">
                            Profil
                        </p>
                    </div>
                )}
            </button>
        </Dropdown>
    );
};
export default UserProfileModal;
